<template>
  <div
    class="relative overflow-y-auto overflow-x-auto flex-1 min-h-0 bg-card border border-border rounded-xl dark:border-gray-700 dark:bg-white/3 custom-scroll"
  >
    <table class="w-full text-left border-collapse">
      <slot />
    </table>
  </div>
</template>

<style scoped>
.custom-scroll {
  border-radius: 0.75rem;
}
.custom-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
  margin-block: 8px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}
.dark .custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
</style>
